import { NdpsDomainResponse } from '../types/bff';
import { fetchBff } from './fetch-bff-data';

export const fetchNdpsDomain = async (token: string, domain: string): Promise<NdpsDomainResponse | null> => {
	return fetchBff(`ndps/domain?token=${token}&domain=${domain}`);
};
